import { Code2, Briefcase, Users, Crown, FileSignature, Cog } from "lucide-react";

const services = [
  {
    icon: Code2,
    title: "IT Recruitment",
    desc: "Sourcing skilled IT professionals — software developers, data scientists, cloud engineers, cybersecurity experts, and more.",
    tone: "teal",
  },
  {
    icon: Briefcase,
    title: "Non-IT Recruitment",
    desc: "End-to-end hiring for sales, marketing, finance, operations, HR, and administration roles.",
    tone: "orange",
  },
  {
    icon: Users,
    title: "Bulk Hiring",
    desc: "Pan-India recruitment drives for new office launches, seasonal needs, and structured onboarding.",
    tone: "teal",
    highlight: true,
  },
  {
    icon: Crown,
    title: "Executive Search",
    desc: "Identifying and placing senior leadership, C-suite, and critical niche professionals.",
    tone: "orange",
  },
  {
    icon: FileSignature,
    title: "Contract / C2H",
    desc: "Flexible staffing for short-term, project-based, and temp-to-perm hiring requirements.",
    tone: "teal",
  },
  {
    icon: Cog,
    title: "Recruitment Process Outsourcing (RPO)",
    desc: "Full-cycle recruitment management outsourced to WorkingBees — from job posting to onboarding.",
    tone: "orange",
  },
];

const toneClasses = {
  teal: "bg-bee-teal/10 text-bee-teal group-hover:bg-bee-teal group-hover:text-white",
  orange: "bg-bee-orange/10 text-bee-orange group-hover:bg-bee-orange group-hover:text-white",
};

export default function Services() {
  return (
    <section id="services" className="py-20 lg:py-28 bg-secondary/40" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-bee-orange font-semibold mb-3">Our Services</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
            Hiring solutions, built for{" "}
            <span className="text-bee-teal">every kind of growth</span>.
          </h2>
          <p className="mt-5 text-base lg:text-lg text-muted-foreground">
            From single niche hires to bulk drives across geographies — we have the right model for your team.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => (
            <div
              key={s.title}
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`group relative rounded-2xl border bg-card p-6 card-lift ${
                s.highlight ? "border-bee-teal/40 ring-1 ring-bee-teal/10" : "border-border"
              }`}
            >
              {s.highlight && (
                <span className="absolute top-4 right-4 px-2 py-0.5 rounded-full bg-bee-honey text-[10px] font-bold uppercase tracking-wider text-bee-teal-dark">
                  Specialty
                </span>
              )}
              <div className={`h-12 w-12 rounded-xl inline-flex items-center justify-center transition-colors ${toneClasses[s.tone]}`}>
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold tracking-tight">{s.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
